<div class="flex flex-col items-end gap-1 text-xs text-gray-500">
  <div>W Twoim koszyku znajdują się produkty z płatnością cykliczną.</div>
  @for (item of recursive(); track item) {
    <div class="flex gap-1">
      <div>Najbliższe pobranie opłaty nastąpi dnia:</div>
      <div class="font-bold">
        <app-date [date]="item.firstRenewalDate" />
      </div>
      <div>w kwocie</div>
      <div class="font-bold">
        <app-currency [amount]="item.price" />
      </div>
      <span class="-ml-1">.</span>
    </div>
  }
</div>
